import { Link } from "react-router-dom";
import { BadgeCheck, Building2, Globe, MapPin, Users } from "lucide-react";

export const CompanyLogo = ({ c, size = "h-14 w-14" }) => (c.logo_url
  ? <img src={c.logo_url} alt={`${c.org_name} logo`} className={`${size} shrink-0 rounded-xl border bg-white object-contain p-1`} data-testid="company-logo" />
  : <div className={`${size} flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-teal-500 to-sky-600 text-lg font-extrabold text-white`}>{(c.org_name || "?").slice(0, 1)}</div>);

export default function CompanyCard({ c, link = true }) {
  if (!c || !(c.about || c.logo_url)) return null;
  return (
    <div className="rounded-2xl border border-l-4 border-l-teal-500 bg-white p-5" data-testid="company-card">
      <div className="flex items-center gap-4">
        <CompanyLogo c={c} />
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 font-semibold">{c.org_name}{c.verified && <BadgeCheck className="h-4 w-4 text-teal-600" aria-label="Verified company email" />}</p>
          <p className="flex flex-wrap gap-x-3 text-xs text-slate-500">
            {c.industry && <span>{c.industry}</span>}{c.size && <span><Users className="mr-0.5 inline h-3 w-3" />{c.size} employees</span>}
            {c.headquarters && <span><MapPin className="mr-0.5 inline h-3 w-3" />{c.headquarters}</span>}</p>
        </div>
      </div>
      {c.about && <p className="mt-3 whitespace-pre-wrap text-sm text-slate-700">{c.about}</p>}
      <div className="mt-3 flex flex-wrap gap-4 text-sm">
        {c.website && <a href={c.website} target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center gap-1 text-teal-700 hover:underline" data-testid="company-website"><Globe className="h-3.5 w-3.5" />Website</a>}
        {link && c.about && <Link to={`/company/${c.company_id}`} className="inline-flex items-center gap-1 text-teal-700 hover:underline" data-testid="company-page-link"><Building2 className="h-3.5 w-3.5" />All jobs at {c.org_name}</Link>}
      </div>
    </div>
  );
}
